import { render, staticRenderFns } from "./NotificationLeadTemplate.vue?vue&type=template&id=46964bb2&"
import script from "./NotificationLeadTemplate.vue?vue&type=script&lang=js&"
export * from "./NotificationLeadTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports